import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AlertService } from '../services/alert.service';
import { AuthService } from '../services/auth.service';
import { ConfirmationService } from '../services/confirmation.service';
import { RoleAuthorisationService } from '../services/role-authorisation.service';

export interface EndpointRolesMap {
  [endpoint: string]: string[]
}


@Injectable({
  providedIn: 'root'
})
export class RoleAuthorisationGuard implements CanActivate {

  constructor(
    private _roleAuth: RoleAuthorisationService,
    private _confirmationService: ConfirmationService,
    private _alertService: AlertService,
    private _authService: AuthService
  ) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    const endpointRolesMap: EndpointRolesMap = {
      'portal': [

      ],
      'dashboard': [
        'SuperAdmin'
      ],
      'submit': [
        'SuperAdmin',
        'Prescription',
        'Customer',
      ],
      'prescriptions': [
        'SuperAdmin',
        'Prescription',
        'Fulfilment',
        'Packaging'
      ],
      'prescriptions/review': [
        'SuperAdmin',
        'Prescription',
        'Fulfilment',
        'Packaging'
      ],
      'batches/create': [
        'SuperAdmin',
        'Fulfilment',
        'Packaging'
      ],
      'batches': [
        'SuperAdmin',
        'Prescription',
        'Fulfilment',
        'Packaging'
      ],
      'individuals/create': [
        'SuperAdmin',
        'Prescription'
      ],
      'individuals': [
        'SuperAdmin',
        'Prescription'
      ],
      'companies/create': [
        'SuperAdmin',
        'Prescription'
      ],
      'companies': [
        'SuperAdmin',
        'Prescription'
      ],

      'medicine/create': [
        'SuperAdmin',
        'Prescription'
      ],

      'medicine': [
        'Prescription',
        'Customer',
        'SuperAdmin',
        'Fulfilment',
        'Packaging'
      ],
      'logs': [
        'SuperAdmin'
      ],
      'integrations': [
        'SuperAdmin'
      ],
      'invoices': [
        'SuperAdmin'
      ]
    };

    // I am giving you a second chance
    if (!this._authService.isAuthenticated()) return true;

    const user = await this._authService.authenticateUser();

    let path: string | null | undefined = route.routeConfig ? route.routeConfig.path : null;

    if (path === '') path = 'portal';

    const roles: string[] = path ? endpointRolesMap[path] : [];

    const authorized = this._roleAuth.isAuthorised(roles);

    if (!authorized)
      this._alertService.errorAlert("Unauthorized access");

    return authorized;


  }

}


